export default "__VITE_ASSET__38b52c85__"